import { render, staticRenderFns } from "./DashboardLeadtime.vue?vue&type=template&id=2b090c66&scoped=true&"
import script from "./DashboardLeadtime.vue?vue&type=script&lang=js&"
export * from "./DashboardLeadtime.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLeadtime.vue?vue&type=style&index=0&id=2b090c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b090c66",
  null
  
)

export default component.exports